import Constants, { LoyaltyHeaderMenu, Status } from '../common/constants';
import { IsEmpty } from '../common/checks';
import { AvailableImages, DesignTypeOptions } from '../sites/Business/LoyaltyProgram/LoyaltyCard/constants';

const { ReduxAction } = Constants;

const initialState = {
  tab:                    LoyaltyHeaderMenu.Design,
  selectedLoyaltyProgram: {
    id:                   '',
    pageId:               '',
    image:                null,
    name:                 ``,
    expiryDate:           null,
    validityInMonths:     null,
    outlets:              [],
    participateOutlets:   [],
    additionalTnC:        '',
    status:               Status.Draft,
    pauseVoucherIssuance: false,
    vouchers:             [
      // { id: 'b82b4fae-5981-41f5-a646-737c0072cfbc', isProduct: true, terms: 'Free Bag', design: '/images/voucher-green.png', issuableQty: 100, balQty: 100, minSpend: null, productImage: null },
      // { id: 'b7f26acc-d7be-4bb2-a4a9-07ed3cfa8e41', isProduct: false, terms: '$2 Off', design: null, issuableQty: 200, balQty: 0, minSpend: 3, productImage: null },
    ],
    selectedVoucherId: null,
    stamp:             {
      numOfStamps:      10,
      amountPerStamp:   1,
      redeemStampImage: null,
    },
    design: {
      designType:                   DesignTypeOptions.Template,
      uploadedDesign:               null,
      stampsHolderBackgroundColour: null,
      templatePreview:              AvailableImages[0].image,
      selectedLoyaltyCardTemplate:  AvailableImages[0].top,
      selectedStampsHolderTemplate: AvailableImages[0].btm,
    },
    /*id:          '1',
    name:       'Test Title',
    image: null,
    expiryDate: null,
    validityInMonths: null,
    validityInDays: null,
    additionalTnC: '',
    */
  },
  savingLC:              false,
  showSaveBtn:           true,
  disableSaveBtn:        false,
  withAdvancedStatusBtn: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ReduxAction.LoyaltyProgramSelected:
      return {
        ...state,
        selectedLoyaltyProgram: IsEmpty(payload)
          ? {}
          : payload,
      };

    case ReduxAction.LoyaltyProgramDataUpdate:
      return {
        ...state,
        selectedLoyaltyProgram: {
          ...state.selectedLoyaltyProgram,
          /**
           * 'payload' to contain the fields we are updating.
           * This allows us to update specific info
           *
           * E.g
           * payload = {
           *    name: '',
           * }
           *
           */
          ...payload,
        },
      };

    case ReduxAction.LoyaltyProgramFinishSaving:
      return {
        ...state,
        savingLC: false,
      };

    case ReduxAction.LoyaltyProgramStartSaving:
      return {
        ...state,
        savingLC: true,
      };

    case ReduxAction.LoyaltyTabUpdate:
      return {
        ...state,
        tab: payload,
      };

    case ReduxAction.LoyaltyProgramSaveBtnHide:
      return {
        ...state,
        showSaveBtn: false,
      };

    case ReduxAction.LoyaltyProgramSaveBtnShow:
      return {
        ...state,
        showSaveBtn: true,
      };

    case ReduxAction.LoyaltyProgramEnableSaveBtn:
      return {
        ...state,
        disableSaveBtn: false,
      };

    case ReduxAction.LoyaltyProgramDisableSaveBtn:
      return {
        ...state,
        disableSaveBtn: true,
      };

    case ReduxAction.LoyaltyProgramShowAdvancedStatusBtn:
      return {
        ...state,
        withAdvancedStatusBtn: true,
      };

    case ReduxAction.LoyaltyProgramHideAdvancedStatusBtn:
      return {
        ...state,
        withAdvancedStatusBtn: false,
      };

    default:
      return state;
  }
}
